import { useMemo } from 'react';

import { useChat } from '@/features/ai-chat/state/useChat';
import { FeatureFlag } from '@/services/feature-flags';
import { useFlag } from '@/services/feature-flags/react';

import type { UIMessage } from '@tanstack/ai-client';

export function useHumanMessage(msg: UIMessage) {
  const promptShareEnabled = useFlag(FeatureFlag.AiPromptShareEnabled);
  const { animatedHumanId, animatedText, onAnimatedComplete } = useChat();

  const shouldAnimate = useMemo(
    () => animatedHumanId === msg.id && !!animatedText,
    [animatedHumanId, animatedText, msg.id]
  );

  return { promptShareEnabled, animatedText, onAnimatedComplete, shouldAnimate } as const;
}
